var map = {
	"./cert-E-commerce-cpttm.jpg": 434,
	"./cert-customer-cpttm.jpg": 435,
	"./cert-finance-cpttm.jpg": 437,
	"./cert-fsi-cpttm.jpg": 439,
	"./cert-general-staff-a-cpttm.jpg": 441,
	"./cert-general-staff-cpttm.jpg": 443,
	"./cert-general2024-cpttm.jpg": 371,
	"./cert-hr-cpttm.jpg": 444,
	"./cert-it-cpttm.jpg": 445,
	"./cert-market-cpttm.jpg": 446,
	"./cert-ngo-cpttm.jpg": 447,
	"./cert-senior-manager-cpttm.jpg": 449,
	"./cert-startup-cpttm.jpg": 450,
	"./cert-student-cpttm.jpg": 452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3272;